import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { NAdventCalendar } from '../advent-calendar.component';

@DfModal({
    id: NAdventCalendar.modalId,
    position: (size: ISizeName) => 'custom',
    config: (size: ISizeName) => ({
        hasBackdrop: true,
        width: { S: '312px', M: '384px', L: '426px', X: '426px' }[size]
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => ({ S: ['S'], M: ['M', 'L', 'X'], L: ['M', 'L', 'X'], X: ['M', 'L', 'X'] })[sizeId]
})
@Component({
    templateUrl: './advent-calendar-modal.html',
    styleUrls: ['./advent-calendar-modal.scss'],
    standalone: true,
    imports: [SizeClassDirective, TranslationModule, ImageModule, NgClass, PriceComponent, HrefComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdventCalendarModalComponent extends UiComponent {
    protected ETileStatus = NAdventCalendar.ETileStatus;
    /**
     * Close advent-calendar
     */
    constructor(
        private modalRef: ModalRef<AdventCalendarModalComponent>,
        @Inject(MODAL_DATA) readonly data: { tile: NAdventCalendar.IExtendedTile; component: NAdventCalendar.IData }
    ) {
        super();
    }

    /**
     * Close advent-calendar
     */
    close() {
        this.modalRef.close();
    }
}
